import Account from '@/models/Account'
import Api from '@/api'
import { each, find, findIndex } from 'lodash'

export default {
  namespaced: true,
  state: {
    customAccount: null,
    list: []
  },

  mutations: {
    setCustomAccount(state, customAccount) {
      state.customAccount = customAccount
    },

    setAccountList(state, accounts) {
      each(accounts, account => {
        const exist = find(state.list, { id: account.id })
        if (!exist) {
          state.list.push(new Account(account))
        }
      })
    },

    clearAccountListItemDetails(state, id) {
      const index = findIndex(state.list, { id: id })
      state.list.splice(index, 1)
    },

    setAccountListItemDefault(state, id) {
      const current = findIndex(state.list, { default_for_currency: true })
      state.list[current].default_for_currency = false

      const index = findIndex(state.list, { id: id })
      state.list[index].default_for_currency = true
    }
  },

  actions: {
    async getCustomAccount({ commit }, params) {
      const { data } = await Api.get(`auth/connect/account`)
      commit('setCustomAccount', data.data)
      commit('setAccountList', data.data.external_accounts.data)
    },

    async createCustomAccount({ commit }, formData) {
      const { data } = await Api.post(`auth/connect/account`, formData)
      commit('setCustomAccount', data.data)
    },

    async getExternalAccounts({ commit }, params) {
      const { data } = await Api.get(`auth/connect/external-accounts`)
      commit('setAccountList', data.data)
    },

    async createExternalAccount({ commit, state }, formData) {
      const { data } = await Api.post(
        `auth/connect/external-accounts`,
        formData
      )
      state.list.unshift(new Account(data.data))
    },

    async deleteExternalAccount({ commit, state }, id) {
      await Api.delete(`auth/connect/external-accounts/${id}`)
      commit('clearAccountListItemDetails', id)
    },

    async setExternalAccountAsPrimary({ commit, state }, id) {
      await Api.put(`auth/connect/external-accounts/${id}`, {
        default_for_currency: true
      })
      commit('setAccountListItemDefault', id)
    }
  }
}
